export const getConflicts = ({ conflicts } = {}) => conflicts || [];
